import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { getUser } from "~/data/user/user.service";

export const userQuery = queryOptions({
  queryKey: ["user"],
  queryFn: () => getUser(),
  staleTime: Infinity,
});

export const useUser = () => {
  const { data } = useSuspenseQuery(userQuery);
  return data;
};
